import URL from '../api_url';

export const CRITERION_API = `${URL}/criterion`;

export const CRITERIONS_API = `${URL}/criterions`;
